import { Query } from "@gen/app-query";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { GridRenderCellParams } from "@mui/x-data-grid";

import { useCanExecuteOperation } from "~/contexts/auth_query";

interface UserCellProps extends GridRenderCellParams {
  userId: string;
  userTransactionRole: "buyer" | "seller";
}

export function UserCell({ userId, row, userTransactionRole }: UserCellProps) {
  const canExecuteOperation = useCanExecuteOperation();
  const clientId = row.client_id;

  const { data: userData } = Query.useCore_getClientUserQuery(
    clientId,
    userId,
    {
      enabled:
        canExecuteOperation("core.getClientUser") && !!clientId && !!userId,
    },
  );

  const email = userData?.email;
  const displayValue = email || userId;

  const isGuest =
    userTransactionRole === "buyer" ? row.buyer_is_guest : row.seller_is_guest;

  if (!displayValue) {
    return <span>-</span>;
  }

  return (
    <Stack flexDirection="column" alignItems="flex-start">
      <Typography variant="body2">{displayValue}</Typography>
      <Stack direction="row" alignItems="center">
        {isGuest && (
          <Typography variant="caption" color="warning.main" fontWeight="bold">
            Guest&nbsp;
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
